import React from 'react';
import { Box, FormGroup, useMediaQuery } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsCheckboxWithLabel from 'ui-elements/form-elements/FsCheckboxWithLabel';
import useTheme from '@material-ui/core/styles/useTheme';
import {
  BankHeaderBox,
  WrapperBox,
} from './SingleAccountExportSelector.style-elements';

export enum ExportFileType {
  EXCEL = 'excel',
  PDF = 'pdf',
}

export interface SingleAccountExportPayloadProps {
  name: string;
  id: string;
  [ExportFileType.EXCEL]: boolean;
  [ExportFileType.PDF]: boolean;
}

export interface SingleAccountExportSelectorProps {
  name: string;
  id: string;
  currency: string;
  onChange: (payload: SingleAccountExportPayloadProps) => void;
}

const SingleAccountExportSelector: React.FC<SingleAccountExportSelectorProps> = ({
  name,
  id,
  currency,
  onChange,
}) => {
  const [state, setState] = React.useState({
    [ExportFileType.EXCEL]: false,
    [ExportFileType.PDF]: false,
  });
  const theme = useTheme();
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newState = { ...state, [event.target.name]: event.target.checked };
    setState(newState);
    onChange({
      name,
      id,
      ...newState,
    });
  };

  return (
    <WrapperBox>
      <BankHeaderBox>
        <FsBodySmall>{`${currency} | ${name}`}</FsBodySmall>
      </BankHeaderBox>
      <Box display="flex">
        <FormGroup row={isUpMd}>
          <FsCheckboxWithLabel
            label="Excel file"
            name={ExportFileType.EXCEL}
            onChange={handleChange}
            checked={state.excel}
            data-test="excel-checkbox"
          />
          <FsCheckboxWithLabel
            label="Pdf file"
            name={ExportFileType.PDF}
            onChange={handleChange}
            checked={state.pdf}
            data-test="pdf-checkbox"
          />
        </FormGroup>
      </Box>
    </WrapperBox>
  );
};

export default SingleAccountExportSelector;
